import validate from "C:/opt/yoien-cloud-frontend/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.25_db0@0.3.4_esli_vgl5iqhs6sch3xui4y7irej3de/node_modules/nuxt/dist/pages/runtime/validate.js";
import param_45check_45global from "C:/opt/yoien-cloud-frontend/middleware/paramCheck.global.ts";
import manifest_45route_45rule from "C:/opt/yoien-cloud-frontend/node_modules/.pnpm/nuxt@3.20.1_@parcel+watcher@2.5.1_@types+node@24.10.1_@vue+compiler-sfc@3.5.25_db0@0.3.4_esli_vgl5iqhs6sch3xui4y7irej3de/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  param_45check_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}